import { createModule } from "saga-slice";
import { call, put } from "redux-saga/effects";
import expenseService from "../services/expenseService";

const initialState = {
    list: [],
    categories: [],
    loading: false,
    error: null
};

const expenseSlice = createModule({

    name: 'expenses',
    initialState,
    reducers: {
        list: (state) => {
            state.loading = true;
        },
        create: (state) => {
            state.loading = true;
        },
        update: (state) => {
            state.loading = true;
        },
        delete: (state) => {
            state.loading = true;
        },

        listCategory: (state) => {
            state.loading = true;
        },
        createCategory: (state) => {
            state.loading = true;
        },
        updateCategory: (state) => {
            state.loading = true;
        },
        deleteCategory: (state) => {
            state.loading = true;
        },

        fetchedData: (state, payload) => {
            state.loading = false;
            state.list = payload;
        },
        fetchedCategories: (state, payload) => {
            state.loading = false;
            state.categories = payload;
        },

        finishFetching: (state) => {
            state.loading = false;
        },
        fetchError: (state, action) => {
            state.loading = false;
            state.error = action || "An error occurred";
        },
    },
    sagas: (A) => ({
        *[A.list]({ payload }) {
            try {
                const {data} = yield call(expenseService.list, payload);
                yield put(A.fetchedData(data));
            } catch (error) {
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.create]({ payload }) {
            try {
                const {data} = yield call(expenseService.create, payload.data);
                yield put(A.finishFetching());
                yield call(payload.onSuccess,data.body);
            } catch (error) {
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        
        *[A.update]({ payload }) {
            try {
                const {data} = yield call(expenseService.update, payload.data);
                yield put(A.finishFetching());
                yield call(payload.onSuccess,data);
            } catch (error) {
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.delete]({ payload }) {
            try {
                console.log("payload", payload);
                const {data} = yield call(expenseService.delete, payload);
                
                yield put(A.finishFetching());
                yield put(A.list());
            } catch (error) {
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },

        *[A.listCategory]() {
            try {
                const {data} = yield call(expenseService.listCategories);
                console.log("Categories fetched:", data);
                yield put(A.fetchedCategories(data));
            } catch (error) {
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.createCategory]({ payload }) {
            try {
                const {data} = yield call(expenseService.createCategory, payload.data);
                yield put(A.finishFetching());
                yield call(payload.onSuccess,data.body);
            } catch (error) {
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.updateCategory]({ payload }) {
            try {
                const {data} = yield call(expenseService.updateCategory, payload.data);
                yield put(A.finishFetching());
                yield call(payload.onSuccess(data.body));
            } catch (error) {
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.deleteCategory]({ payload }) {
            try {
                const {data} = yield call(expenseService.deleteCategory, payload);
                yield put(A.finishFetching());
                yield put(A.listCategory());
            } catch (error) {
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        }
    }),
});

export default expenseSlice;
export const expenseActions = expenseSlice.actions;


